import { SearchAction, searchActions } from 'modules/app/redux/creators';
import { IMPORTED_ORGANIZATION_FILTER_KEY } from 'modules/importedOrganizations/constants';
import { getType } from 'typesafe-actions';
import { FilterActions, filterActions } from '../../actions/creators';
import { ImportedOrganizationFilters } from '../../../types/importedOrganization';
import { OrganizationStatus } from '../../../../organization/types/organization';

const initialState: ImportedOrganizationFilters = {
  status: [OrganizationStatus.Imported],
};

const filterReducer = (state: ImportedOrganizationFilters = initialState, action: SearchAction | FilterActions) => {
  switch (action.type) {
    case getType(searchActions.setSearch):
      return action.payload.filterKey === IMPORTED_ORGANIZATION_FILTER_KEY
        ? { ...state, search: action.payload.searchText }
        : state;

    case getType(searchActions.clearSearch):
      const newState = { ...state };
      delete newState.search;

      return newState;

    case getType(filterActions.setStatusFilter):
      const isActive = state.status && state.status.includes(action.payload);
      const newStatuses = state.status
        ? isActive
          ? state.status.filter((status) => status !== action.payload)
          : [...state.status, action.payload]
        : [action.payload];

      return { ...state, status: newStatuses };
    default:
      return state;
  }
};

export default filterReducer;
